import React from 'react';
import { Chip } from '@mui/material';
import { getStatusStringColor } from '../../lib/utils';

function StatusPill({ status, repair = false }) {
  const color = status === 'Open' && repair ? '#66bb6a' : 'white';
  const backgroundColor = getStatusStringColor(status, repair);
  const borderColor = status === 'Open' && repair ? '#66bb6a' : '';
  return (
    <Chip
      label={status}
      sx={{
        color,
        backgroundColor,
        padding: '2px, 3px',
        height: 25,
        borderColor,
      }}
      variant={repair ? 'outlined' : 'filled'}
    />
  );
}

export default StatusPill;
